module.exports = __webpack_public_path__ + "static/media/bomb.97253bf1.png";